import React from "react";

/* eslint-disable max-len */
export default function DownloadIcon({size}: { size?: number }) {
    return (
        <svg width={size || 10} height={size || 10} viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5 7.5L5 -1.31134e-07M5 7.5L2 4.5M5 7.5L8 4.5" stroke="#D6001C"/>
            <path d="M1 9.5L9 9.5" stroke="#D6001C"/>
        </svg>
    );
}
